import APIController from '../core-api-controller';

export const sendSubscriptionId = (data) => {
  const path = `${APIController.endpointApi}/users/handle_onesignal_subscription`;
  return APIController.postCallback(path, data);
};

export const fetchFirebaseToken = () => {
  const path = `${APIController.endpointApi}/users/fetch_firebase_token`;
  return APIController.getApiCallback(path);
};
